import { HIDE_GLOBAL_SETTING, SettingActionType, SettingState, SHOW_GLOBAL_SETTING } from './types';

const initialState: SettingState = {
    isGlobalSettingVisible: false,
};
export default function settingReducer(
    state = initialState,
    action: SettingActionType,
): SettingState {
    switch (action.type) {
        case SHOW_GLOBAL_SETTING:
            return {
                ...state,
                isGlobalSettingVisible: true,
            };
        case HIDE_GLOBAL_SETTING:
            return {
                ...state,
                isGlobalSettingVisible: false,
            };
        default:
            return { ...state };
    }
}
